import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Card({ interactive, className, ...rest }) {
    return (_jsx("div", { className: cn("fwfa-card", interactive && "fwfa-card--interactive", className), ...rest }));
}
//# sourceMappingURL=Card.js.map